module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/costume_03@3x-5f18bdabf3ed742b6508765259f0f3df.webp";